import axios from '@/plugins/axios';
import { logApiError } from '@/services/api.js';

const baseUrl = '/api/credits';

const DEFAULT_CUSTOM_BOUNDS = { min_usd: 5, max_usd: 500 };

export const getApiCreditsBalance = async () => {
  try {
    const response = await axios.get(`${baseUrl}/balance`);
    return response.data;
  } catch (error) {
    logApiError(error, 'GET', `${baseUrl}/balance`);
    throw error;
  }
};

export const getApiCreditsLedger = async ({ skip = 0, take = 50 } = {}) => {
  try {
    const response = await axios.get(`${baseUrl}/ledger`, {
      params: { skip, take },
    });
    return response.data;
  } catch (error) {
    logApiError(error, 'GET', `${baseUrl}/ledger`);
    throw error;
  }
};

export const getApiCreditPackages = async () => {
  try {
    const response = await axios.get(`${baseUrl}/packages`);
    const data = response.data;
    if (Array.isArray(data)) {
      return { packages: data, custom: { ...DEFAULT_CUSTOM_BOUNDS } };
    }
    return {
      packages: Array.isArray(data?.packages) ? data.packages : [],
      custom: {
        min_usd: Number(data?.custom?.min_usd) || DEFAULT_CUSTOM_BOUNDS.min_usd,
        max_usd: Number(data?.custom?.max_usd) || DEFAULT_CUSTOM_BOUNDS.max_usd,
      },
    };
  } catch (error) {
    logApiError(error, 'GET', `${baseUrl}/packages`);
    throw error;
  }
};

export const createApiCreditsTopUp = async ({ packageId, amountUsd } = {}) => {
  try {
    const payload = {};
    if (packageId && packageId !== 'custom') {
      payload.package_id = packageId;
    } else if (amountUsd != null) {
      payload.amount_usd = Number(amountUsd);
    }
    const response = await axios.post(`${baseUrl}/top-up`, payload);
    return response.data;
  } catch (error) {
    logApiError(error, 'POST', `${baseUrl}/top-up`);
    throw error;
  }
};
